import { render, staticRenderFns } from "./PassageView.vue?vue&type=template&id=29a7fe4a&scoped=true&"
import script from "./PassageView.vue?vue&type=script&lang=js&"
export * from "./PassageView.vue?vue&type=script&lang=js&"
import style0 from "./PassageView.vue?vue&type=style&index=0&id=29a7fe4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a7fe4a",
  null
  
)

export default component.exports